export default {
  ADD_TIER_REQUEST: "ADD_TIER_REQUEST",
  ADD_TIER_FAILED: "ADD_TIER_FAILED",
  ADD_TIER_SUCCESS: "ADD_TIER_SUCCESS",

  UPDATE_TIER_REQUEST: "UPDATE_TIER_REQUEST",
  UPDATE_TIER_FAILED: "UPDATE_TIER_FAILED",
  UPDATE_TIER_SUCCESS: "UPDATE_TIER_SUCCESS",

  FETCH_TIERS_REQUEST: "FETCH_TIERS_REQUEST",
  FETCH_TIERS_FAILED: "FETCH_TIERS_FAILED",
  FETCH_TIERS_SUCCESS: "FETCH_TIERS_SUCCESS",

  DELETE_TIER_REQUEST: "DELETE_TIER_REQUEST",
  DELETE_TIER_FAILED: "DELETE_TIER_FAILED",
  DELETE_TIER_SUCCESS: "DELETE_TIER_SUCCESS"
};
